import { CSSObject } from '@chakra-ui/react';

export const BoxPageWrapper: CSSObject = {
  px: '0',
};

export const BoxSectionWrapper: CSSObject = {
  mb: ['3', '3.5'],
  px: 0,
};

export const BoxSportWrapper: CSSObject = {
  borderColor: 'transparent',
  borderRadius: 'base',
  border: 'none',
  bg: 'transparent',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
};

export const TextTitle: CSSObject = {
  color: 'white',
  fontSize: 'md',
  fontFamily: 'body',
  fontWeight: 'extrabold',
};

export const LinkItem: CSSObject = {
  color: 'white',
  borderRadius: 'md',
  bgGradient:
    'linear(to-b, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.05))',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
  border: '1px solid rgba(255, 255, 255, 0.16)',
  h: '42px',
  mb: ['1', '2'],
  _first: { borderTop: '1px solid rgba(255, 255, 255, 0.16)' },
  _last: { mb: '0' },

  _hover: {
    bgGradient:
      'linear(to-b, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08))',
  },
};

export const IconSport: CSSObject = {
  color: 'beta.300',
  filter: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.25))',
};

export const IconChevron: CSSObject = {
  boxSize: '5',
  border: 'none',
  p: '1',
  color: 'white',
};

export const TextName: CSSObject = {
  fontFamily: 'accent',
  fontSize: 'sm',
  fontWeight: 'bold',
  lineHeight: 'normal',
};
